(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('emptyPage', {
            templateUrl: 'app/components/empty-page/empty-page.html',
            controller: emptyPageController,
            bindings: {
                name: '@',
                description: '@',
                image: '@'
            }
        });

    /** @ngInject */
    function emptyPageController() {
    }
})();
